// extracted by mini-css-extract-plugin
module.exports = {"rightColumn":"style-module__rightColumn___mVAPm","select":"style-module__select___2dP_C"};